module.exports = __webpack_public_path__ + "static/media/AB_O1_16.9f5bd098.jpg";